// extracted by mini-css-extract-plugin
export default {"message":"Message_message__UdveK","error":"Message_error__yFZBo","success":"Message_success__KxHb2"};